// THIS SIGN IN PAGE IS JUST FOR DEVELOPMENT TO QUICKLY SWITCH TO TEST ACCOUNT
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Form, Header, Message } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getUserInfo, signIn } from '../../reducers/user';

class SignIn extends Component {

  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      loading: false,
      username: '',
      password: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillUnmount() {
    this.props.getUserInfo();
    this.setState({loading: false});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user.error) {
      this.setState({loading: false});
    }
  }

  handleChange(e, { name, value }) {
    this.setState({ [name]: value });
  } 

  handleSubmit(e) {
    const { username, password } = this.state;
    this.setState({ loading: true }, () => {
      this.props.signIn(username, password);
    });
  }

  renderErrorMessage() {
    if (this.props.user.errorCode === 429) {
      return  (
        <Message warning>
          <Message.Header>Odota hetki!</Message.Header>
          <p>Useita kirjautumisyrityksiä. Yritä hetken päästä uudestaan.</p>
        </Message>);     
    }
    
    return (
      <Message negative>
        <Message.Header>Sisäänkirjautuminen epäonnistui!</Message.Header>
        <p>Tarkasta käyttäjänimi ja salasana.</p>
      </Message>);
  }

  render() {
    const { username, password } = this.state;
    
    if (this.props.user.isLoggedIn) {
      return <Redirect to='/' />;
    }
    
    return (
      <div>
        <Header as='h2'>Tervetuloa!</Header>
        <Header as='h4'>Kirjaudu sisään</Header>
        <Form onSubmit={this.handleSubmit}>
          <Form.Group>
            <Form.Input placeholder='Käyttäjänimi' name='username' value={username} onChange={this.handleChange} />
            <Form.Input
              placeholder='Salasana'
              name='password'
              type='password'
              value={password}
              onChange={this.handleChange}
            />
            <Form.Button loading={this.state.loading} content='Lähetä' />
          </Form.Group>
        </Form>
        {this.props.user.error ? this.renderErrorMessage() : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  getUserInfo: () => getUserInfo(),
  signIn: (username, password) => signIn(username, password)
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignIn);



// WEBPACK FOOTER //
// ./src/containers/signin/index.js